import { Card, styled } from '@mui/material'

export const StyledCard = styled(Card)(() => ({
  padding: '20px',
}))
